namespace SorAraBul.PropertyManagement {

    @Serenity.Decorators.registerFormatter()
    export class LinkFormatter implements Slick.Formatter {

        format(ctx: Slick.FormatterContext): string {
            if (!ctx.value)
                return "";

            const baseUrl = window.location.origin; 
            const fullUrl = `${baseUrl}${ctx.value}`;

            if (ctx.item.Status > 0)
                return `<div class="tenant-form-cell"><a href="javascript:;" class="tenant-detail tenant-form-action tenant-form-action-view" title="Formu görüntüle" rel="noopener noreferrer"><i class="fa fa-eye"></i></a></div>`;
            else
                return `<div class="tenant-form-cell"><a href="${Q.attrEncode(fullUrl)}" target="_blank" rel="noopener noreferrer" class="tenant-form-action tenant-form-action-link" title="Form linkini aç"><i class="fa fa-link"></i></a></div>`;
        }
    }
}
